import { Container } from '@mui/material'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import StepOne from 'components/organisms/user/onboardingSteps/StepOne'
import StepTwo from './onboardingSteps/StepTwoNew'
import StepThree from './onboardingSteps/StepThree'
import StepFour from './onboardingSteps/StepFour'
import { getLocalUser } from 'utils/localStorage'
import { getGoalInfoById } from 'utils/getSupportingInfo'
import StepperPageTemplate from 'components/templates/StepperPageTemplate'
import InCardStack from 'components/atoms/container/InCardStack'
import { MY_JOURNEY } from 'routes/constants'
import AddRaterPageCard from '../assessments/AddRaterPageCard'

const OnboardingCard = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [selectedGoal, setSelectedGoal] = useState({})
  const [assessmentData, setAssessmentData] = useState({})
  const userInfo = getLocalUser()

  // Set initial active step
  const profileCompleted = Boolean(userInfo.department && userInfo.job)

  const forProfile = location.state?.completeProfile === true
  const initialStep = forProfile
    ? 2
    : profileCompleted
      ? 3
      : 1
  const [activeStep, setActiveStep] = useState(initialStep)

  // Callback from goal select screen
  const handleSelectGoal = () => {
    setActiveStep(4)
  }

  useEffect(() => {
    const fetchData = async () => {
      if (userInfo?.userStates?.currentGoalId) {
        const goal = await getGoalInfoById(userInfo.userStates.currentGoalId)
        setSelectedGoal(goal)
      }
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (location.state && location.state?.selectedGoal) {
      setSelectedGoal(location.state.selectedGoal)
      handleSelectGoal()
    }
  }, [location.state])

  // If user have preset goal
  useEffect(() => {
    const fetchData = async () => {
      if (userInfo.userStates.currentGoalId) {
        const goal = await getGoalInfoById(userInfo.userStates.currentGoalId)
        setSelectedGoal(goal)
      }
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSelfAssessmentFinish = (assessmentResult) => {
    if (selectedGoal?.enableOthersAssessment) {
      setAssessmentData(assessmentResult)
      setActiveStep(5)
    } else {
      navigate(MY_JOURNEY)
    }
  }

  const onboardingSteps = [
    'welcomeArea.welcome',
    'onboarding.createProfile',
    'onboarding.selectPath',
    'onboarding.selfAssessment',
    'onboarding.inviteOthersToRate'
  ]
  return (
    <StepperPageTemplate
      activeStep={activeStep}
      steps={onboardingSteps.slice(
        0,
        selectedGoal?.enableOthersAssessment === false ? 4 : 5
      )}
      stepperMaxWidth='lg'>
      <Container maxWidth={activeStep > 2 ? 'xl' : 'sm'}>
        <InCardStack spacing={8} sx={{ paddingBottom: 16 }}>
          {activeStep === 1 ? (
            <StepOne completeCallback={() => setActiveStep(2)} />
          ) : activeStep === 2 ? (
            <StepTwo
              showOptions={true}
              completeCallback={() => setActiveStep(3)}
            />
          ) : activeStep === 3 ? (
            <StepThree
              completeCallback={() => setActiveStep(4)}
              selectedGoal={selectedGoal}
            />
          ) : activeStep === 4 ? (
            <StepFour
              completeCallback={handleSelfAssessmentFinish}
              selectedGoal={selectedGoal}
            />
          ) : activeStep === 5 ? (
            <AddRaterPageCard fromSelfAssessment={true} goalId={selectedGoal.id} assessmentData={assessmentData} />
          ) : null}
        </InCardStack>
      </Container>
    </StepperPageTemplate>
  )
}

export default OnboardingCard
